export default __webpack_public_path__ + "static/Business-Blog-Image-497a3b00a82f19d7c8d708e5f259b974.webp";